var _defs, _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon-package_svg__a",
    d: "M0 0h128v128H0z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-package_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-package_svg__a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-package_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.9 95.3l-1.8 1v-9.2l1.8-1v9.2zM104 77.6l-1.8 1v9.2l1.8-1v-9.2zM122.7 37v61.4l-52 29.6L5.3 90.8V29.4L57.4 0l65.3 37zM48.8 17.1l48.1 27.6 9.1-4.9-48.6-27.5-8.6 4.8zM64 68.7L16 40.9v43.7l48 27.3V68.7zm16.1-14.9L33.1 26l-10.9 6.2 47.3 27.4 10.6-5.8zm31.9-5.1l-10.7 5.7v14.9l-16 9V63.1l-10.7 5.7v44.6L112 92.2V48.7zM85.8 87.9L84 89v9.1l1.9-1v-9.2zm7.5-4.3l-1.8 1v9.2l1.8-1v-9.2zm3.1-1.7l-1.8 1v9.2l1.8-1v-9.2zm3.1-1.8l-1.9 1.1v9.2l1.9-1.1v-9.2z"
  }))));
}

export default SvgIconPackage;